import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import { omOrderBranchPackage, omOrderPackage, omOrderServices, orderBranchPayload, orderCost, orderPaylaod, packageCreate } from 'global/Models/omOrderModel';

export const getPayloadFromPackages = (packages: packageCreate[], orderMethods: orderMethodsState, orderServices: omOrderServices): orderPaylaod => {
  let paymentTypeId = orderMethods.paymentTypeId;
  //each packages have an array of package which have a count property, i need sum of packages.package.count properties
  const parcelCount = packages.reduce((total, obj) => {
    return total + obj.package.reduce((total, obj) => total + (obj.count || 1), 0);
  }, 0);

  if (parcelCount === 0) return {} as orderPaylaod;

  let cashAmount: number | string | undefined = undefined;

  if (orderMethods.paymentTypeId == 70) {
    if (!orderMethods.cashAmount) {
      cashAmount = 0;
    } else {
      try {
        const amount = parseInt(orderMethods.cashAmount + '');
        if (amount > 0) cashAmount = amount / parcelCount;
        else cashAmount = 0;
      } catch (_error) {
        cashAmount = 0;
      }
    }
    if (cashAmount === 0 || cashAmount === undefined) {
      paymentTypeId = 20;
      cashAmount = undefined;
    }
  }

  const payload: omOrderPackage[] = [];
  //loop in order rows
  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    //loop in packages added to order
    for (let k = 0; k < (order.package.length || 1); k++) {
      const packaging = order.package[k];
      //loop [count]times
      for (let p = 0; p < (packaging.count || 1); p++) {
        const jetService = orderServices.find(
          (serivce) =>
            serivce.destCityId.toLowerCase() === order.destinationCity?.jetId?.toLowerCase() && serivce.sourceCityId.toLowerCase() === order.sourceCity?.jetId?.toLowerCase()
        );
        let serviceId = jetService?.serviceList[0].serviceId;
        if (jetService) {
          jetService.serviceList.map((service) => {
            if (service.selected) serviceId = service.serviceId;
          });
        }

        payload.push({
          senderClientId: order.senderClient?.id as number,
          receiverClientId: order.receiverClient?.id as number,
          senderAddressId: order.senderAddress?.address.id as number,
          receiverAddressId: order.receiverAddress?.address.id as number,
          destinationCityId: !!order.receiverAddress?.address.id || !order.lockerInfo ? undefined : order.lockerInfo.cityId,
          enableLabelPrivacy: false,
          // weight: packaging?.weight as number,
          // packageValue: packaging?.price as number,
          // width: packaging?.width as number,
          // length: packaging?.length as number,
          // height: packaging?.height as number,
          // packagingTypeId: packaging?.packagingTypeId as number,
          // packageContentId: packaging?.packagingContentId as number,
          // packagingGroupId: packaging?.packagingGroupId || 20,
          customerPackageId: packaging?.id as number,
          description: packaging?.description || '',
          serviceId: serviceId as number,
          paymentTypeId: paymentTypeId as number,
          cod: orderMethods.haveCOD ? (packaging?.cod ? packaging.cod : packaging.price) : undefined,
          pickupTypeId: orderMethods.pickupTypeId as number,
          deliveryTypeId: orderMethods.deliveryTypeId as number,
          pickupDate: orderMethods.selectedDate as string,
          pickupStartTime: orderMethods.selectedFromHour as string,
          pickupEndTime: orderMethods.selectedToHour as string,
          customerSubstationCode: orderMethods.customerSubstationCode as string,
          cashAmount,
        });
      }
    }
  }

  return {
    packages: payload,

    confirmLockerOrder: {
      orderNumber: packages[0].lockerInfo?.orderNumber as string,
      trackNumber: packages[0].lockerInfo?.trackNumber as string,
      barcode: packages[0].lockerInfo?.barcode as string,
      // payType: packages[0].lockerInfo?.payType as string,
    },
  };
};

export const getPayloadPricingV4 = (packages: packageCreate[], orderMethods: orderMethodsState, orderServices: any): any => {
  const packageInputs: {
    origin: { cityId: number };
    destination: { cityId: number };
    weight: number;
    packageValue: number;
    length: number;
    width: number;
    height: number;
    packingId: number;
    packageContentId: number;
    isUnusual: boolean;
    packType: number;
    paymentType: number;
    pickupType: number;
    distributionType: number;
    serviceId: number;
    barcode?: string;
  }[] = [];

  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    for (let k = 0; k < order.package.length; k++) {
      const packaging = order.package[k];
      const count = Number(packaging.count) || 1;
      const barcodes = Array.isArray(packaging.barcodes) ? packaging.barcodes : [];

      const jetService = orderServices.find(
        (serivce: any) =>
          serivce.destCityId.toLowerCase() === order.destinationCity?.jetId?.toLowerCase() && serivce.sourceCityId.toLowerCase() === order.sourceCity?.jetId?.toLowerCase()
      );
      let serviceId = jetService?.serviceList[0].serviceId;
      if (jetService) {
        jetService.serviceList.map((service: any) => {
          if (service.selected) serviceId = service.serviceId;
        });
      }

      for (let p = 0; p < count; p++) {
        packageInputs.push({
          origin: {
            cityId: order.senderAddress?.address?.cityETipaxId as number,
          },
          destination: {
            cityId: order.receiverAddress?.address?.cityETipaxId as number,
          },
          weight: Number(packaging.weight),
          packageValue: Number(packaging.price),
          length: Number(packaging.length),
          width: Number(packaging.width),
          height: Number(packaging.height) || 1,
          packingId: packaging.packagingTypeId,
          packageContentId: packaging.packagingContentId,

          isUnusual: !packaging.isStandard,
          packType: packaging.packagingGroupId,
          paymentType: orderMethods.paymentTypeId!,
          pickupType: orderMethods.pickupTypeId!,
          distributionType: orderMethods.deliveryTypeId!,
          serviceId: serviceId,
          barcode: barcodes[p] || undefined,
        });
      }
    }
  }

  return {
    packageInputs: packageInputs,
  };
};

export const getBranchPayloadFromPackages = (packages: packageCreate[], orderMethods: orderMethodsState, orderServices: omOrderServices): orderBranchPayload => {
  let paymentTypeId = orderMethods.paymentTypeId;
  //each packages have an array of package which have a count property, i need sum of packages.package.count properties
  const parcelCount = packages.reduce((total, obj) => {
    return total + obj.package.reduce((total, obj) => total + (obj.count || 1), 0);
  }, 0);

  if (parcelCount === 0) return {} as orderBranchPayload;

  let cashAmount: number | string | undefined = undefined;

  if (orderMethods.paymentTypeId == 70) {
    if (!orderMethods.cashAmount) {
      cashAmount = 0;
    } else {
      try {
        const amount = parseInt(orderMethods.cashAmount + '');
        if (amount > 0) cashAmount = amount / parcelCount;
        else cashAmount = 0;
      } catch (_error) {
        cashAmount = 0;
      }
    }
    if (cashAmount === 0 || cashAmount === undefined) {
      paymentTypeId = 20;
      cashAmount = undefined;
    }
  }

  const payload: omOrderBranchPackage[] = [];
  //loop in order rows
  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    //loop in packages added to order
    for (let k = 0; k < (order.package.length || 1); k++) {
      const packaging = order.package[k];
      //loop [count]times
      for (let p = 0; p < (packaging.count || 1); p++) {
        const jetService = orderServices.find(
          (serivce) =>
            serivce.destCityId.toLowerCase() === order.destinationCity?.jetId?.toLowerCase() && serivce.sourceCityId.toLowerCase() === order.sourceCity?.jetId?.toLowerCase()
        );
        let serviceId = jetService?.serviceList[0].serviceId;
        if (jetService) {
          jetService.serviceList.map((service) => {
            if (service.selected) serviceId = service.serviceId;
          });
        }

        // Get the specific barcode for this iteration
        const specificBarcode = packaging.barcodes?.[p] || '';
        console.log(`Package ${i}, packaging ${k}, iteration ${p}:`, {
          packagingBarcodes: packaging.barcodes,
          specificBarcode,
          count: packaging.count,
        });

        payload.push({
          senderClientId: order.senderClient?.id as number,
          receiverClientId: order.receiverClient?.id as number,
          senderAddressId: order.senderAddress?.address.id as number,
          receiverAddressId: order.receiverAddress?.address.id as number,

          serviceId: serviceId as number,
          paymentType: paymentTypeId as number,
          pickupType: orderMethods.pickupTypeId as number,
          pickupDate: orderMethods.selectedDate as string,
          pickupStartTime: orderMethods.selectedFromHour as string,
          pickupEndTime: orderMethods.selectedToHour as string,
          cashAmount,
          weight: packaging.weight,
          packageValue: packaging?.price as number,
          length: packaging.length as number,
          width: packaging.width as number,
          height: packaging.height as number,
          packingId: packaging.packagingTypeId,
          packageContentId: packaging?.packagingContentId as number,
          packType: packaging.packagingGroupId,

          distributionType: orderMethods.deliveryTypeId as number,

          cod: orderMethods.haveCOD ? (packaging?.cod ? packaging.cod : packaging.price) : 0,
          customParcelTitle: '',
          bubbleWrapAmount: packaging.bubbleWrapAmount as number,
          glueAmount: packaging.glueAmount as number,
          salaryAmount: packaging.salaryAmount as number,
          barcodeDetail: {
            preFix: 'PAST',
            infix: /^past/i.test(specificBarcode) ? specificBarcode.replace(/^past/i, '') : specificBarcode,
            postFix: '',
          },
        });
      }
    }
  }

  return {
    packages: payload,
  };
};

export const registerPayloadFoeV = (packages: packageCreate[], orderMethods: orderMethodsState, orderServices: omOrderServices): any => {
  let paymentTypeId = orderMethods.paymentTypeId;

  // Calculate total parcel count
  const parcelCount = packages.reduce((total, obj) => {
    return total + obj.package.reduce((t, p) => t + (p.count ? +p.count : 1), 0);
  }, 0);

  if (parcelCount === 0) return { packages: [] };

  let cashAmount: number | string | undefined = undefined;

  if (orderMethods.paymentTypeId == 70) {
    if (!orderMethods.cashAmount) {
      cashAmount = 0;
    } else {
      try {
        const amount = parseInt(orderMethods.cashAmount + '');
        if (amount > 0) cashAmount = amount / parcelCount;
        else cashAmount = 0;
      } catch (_error) {
        cashAmount = 0;
      }
    }
    if (cashAmount === 0 || cashAmount === undefined) {
      paymentTypeId = 20;
      cashAmount = undefined;
    }
  }

  const payload: omOrderBranchPackage[] = [];

  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    for (let k = 0; k < order.package.length; k++) {
      const packaging = order.package[k];
      const count = packaging.count ? +packaging.count : 1;

      // Find serviceId
      const jetService = orderServices.find(
        (service) =>
          service.destCityId?.toLowerCase() === order.destinationCity?.jetId?.toLowerCase() && service.sourceCityId?.toLowerCase() === order.sourceCity?.jetId?.toLowerCase()
      );
      let serviceId = jetService?.serviceList?.[0]?.serviceId;
      if (jetService) {
        jetService.serviceList.forEach((service) => {
          if (service.selected) serviceId = service.serviceId;
        });
      }

      for (let p = 0; p < count; p++) {
        payload.push({
          senderClientId: order.senderClient?.id as number,
          receiverClientId: order.receiverClient?.id as number,
          senderAddressId: order.senderAddress?.address.id as number,
          receiverAddressId: order.receiverAddress?.address.id as number,

          serviceId: serviceId as number,
          paymentType: paymentTypeId as number,
          pickupType: orderMethods.pickupTypeId as number,
          pickupDate: orderMethods.selectedDate as string,
          pickupStartTime: orderMethods.selectedFromHour as string,
          pickupEndTime: orderMethods.selectedToHour as string,
          cashAmount,
          weight: packaging.weight,
          packageValue: packaging?.price as number,
          length: packaging.length,
          width: packaging.width,
          height: packaging.height || 1,
          packingId: packaging.packagingTypeId,
          packageContentId: packaging?.packagingContentId as number,
          packType: packaging.packagingGroupId,

          distributionType: orderMethods.deliveryTypeId as number,
          cod: 0,
          customParcelTitle: '',
          bubbleWrapAmount: packaging.bubbleWrapAmount,
          glueAmount: packaging.glueAmount,
          salaryAmount: packaging.salaryAmount,
          barcodeDetail: {
            preFix: packaging.barcodeDetail?.preFix,
            infix: packaging.barcodeDetail?.infix,
            postFix: '',
          },
        });
      }
    }
  }

  return {
    packages: payload,
  };
};

export const sumFinalAmounts = (arr: orderCost[]): number => {
  return arr.reduce((total, obj) => {
    if (obj.finalAmount) {
      return total + obj.finalAmount;
    } else {
      return total;
    }
  }, 0);
};

export const orderCODSum = (packages: packageCreate[]) => {
  let total = 0;
  for (let i = 0; i < packages.length; i++) {
    const order = packages[i];
    for (let k = 0; k < order.package.length; k++) {
      const pack = order.package[k];
      const price = pack.cod || pack.price;
      if (!pack.count) total += +price;
      else total += +price * parseInt(pack.count + '');
    }
  }
  return total;
};

export const getOrderSteps = (packages: packageCreate[], currentStep: number) => [
  {
    title: 'اطلاعات سفارش',
    subTitle: packages.length + ' سفارش',
    description:
      currentStep !== 0 ? (
        <div className='flex flex-col text-[10px] inherit-colorf !text-t-text-color'>
          {packages.map((item, index) => {
            if (!item.senderAddress?.address.cityTitle) return null;
            return (
              <span key={item.uuid} className='!text-t-text-color'>
                {index + 1}
                {' - '}
                {item.senderAddress?.address.cityTitle}
                {' --> '}
                {item.package?.length} بسته{' --> '}
                {item.receiverAddress?.address.cityTitle}
              </span>
            );
          })}
        </div>
      ) : (
        <div className='flex'>
          <span className='text-[10px]'>اطلاعات محل جمع آوری و توزیع و بسته ارسالی</span>
        </div>
      ),
  },
  {
    title: 'طریقه پرداخت و ارسال',
    subTitle: '',
    description: '',
  },
  {
    title: 'بازبینی و تایید',
    subTitle: '',
    description: '',
  },
];
